import flatpickr from "flatpickr"
import { Slovak } from "flatpickr/dist/l10n/sk.js"
import { Czech } from "flatpickr/dist/l10n/cs.js"
import './style.scss'

window.makeDate = function makeDate(selectorClass, locale) {
    return flatpickr("."+selectorClass, {
        altInput: true,
        altFormat: "d.m.Y",
        dateFormat: "Y-m-d",
        locale: locale === 'sk' ? Slovak : (locale === 'cs' || locale === 'cz' ? Czech : null),
        minDate: "today",
    });
};
